import { render } from "./PrivacyPolicy.vue?vue&type=template&id=9959df5a&scoped=true"
const script = {}

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=9959df5a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9959df5a"

export default script